import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import jump from 'jump.js';

const FootnoteItem = ({number, text, footnoteText, footnoteLink}) => (
    <div className='footnote' id={`footnote${number}`}>
        <div className='footnote__number'>{ number }.</div>
        <div className='footnote__content'>
            <span className='footnote__reference'>{ text }</span>
            { footnoteLink ? (
                <a target='_blank' rel='noopener noreferrer' href={ footnoteLink } className='footnote__link'>{ footnoteText }</a>
            ) : (
                <span className='footnote__text'>{ footnoteText }</span>
            )}
        </div>
    </div>
);

FootnoteItem.propTypes = {
    number: PropTypes.number,
    text: PropTypes.string,
    footnoteText: PropTypes.string,
    footnoteLink: PropTypes.string,
};

export default class Footnotes extends React.Component {
    render() {
        return (
            <div className='footnotes'>
                {this.props.footnotes && this.props.footnotes.map(item => (
                    <FootnoteItem number={item.number} text={item.text} footnoteText={item.footnoteText} footnoteLink={item.footnoteLink}/>
                ))}
            </div>
        )
    }

    static propTypes = {
        footnotes: PropTypes.array,
    }
}

class FootnoteReference extends React.Component {
    constructor(props) {
        super(props);

        this.jump = this.jump.bind(this);
    }

    jump(event) {
        jump(event.target.getAttribute('href'), {
            duration: 350,
            offset: -10,
            callback: undefined,
            a11y: false
        });
    }

    render() {
        return (
            <a href={`#footnote${this.props.number}`} className='footnote-reference' onClick={this.jump}>
                {this.props.text}
                <span className="footnote-reference__number">{this.props.number}</span>
            </a>
        )
    }
};

const footnotesPlaceholder = document.querySelector('#footnotes');
let footnotesInText = document.querySelectorAll('.js-footnote');
let footnotes = [];
let count = 1;

function runInText() {
    Array.from(footnotesInText).forEach((footnote) => {
        const data = {
            number: count,
            text: footnote.textContent,
            footnoteText: footnote.dataset.text ? footnote.dataset.text : '',
            footnoteLink: footnote.dataset.link ? footnote.dataset.link : '',
        };

        footnotes.push(data);

        ReactDOM.render(<FootnoteReference {...data}/>, footnote);

        count = count + 1;
    });
}

runInText();

function run() {
    if (footnotesPlaceholder && footnotesInText && footnotesInText.length > 0) {
        footnotesPlaceholder.classList.add('has-footnotes');
        ReactDOM.render(
            <Footnotes footnotes={footnotes}/>,
            footnotesPlaceholder
        );
    }
}

const loadedStates = ['complete', 'loaded', 'interactive'];

if (loadedStates.includes(document.readyState) && document.body) {
    run();
} else {
    window.addEventListener('DOMContentLoaded', run, false);
}
